// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKBHi7VGSs850eEt6lC-AxkZ7Rh-U0P_E",
  authDomain: "personal-architect-garages.firebaseapp.com",
  projectId: "personal-architect-garages",
  storageBucket: "personal-architect-garages.firebasestorage.app",
  messagingSenderId: "26492351540",
  appId: "1:26492351540:web:4ed79fbbcfcee9d031c661",
  measurementId: "G-BGHPVY0CWY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);